import React from 'react'
import GoogleSearchAd from './GoogleSearchAd'

const GoogleAdsetForm = ({ dataItem, onChange }) => {
    return (
        <div className='row mt-2 p-2' style={{ minHeight: "260px" }}>
            <div className='col-7 border-end pr-4'>
                <div className="row g-3">
                    <div className="col-6">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="finalUrl">Final URL *</label>
                        <input
                            type="text"
                            name="finalUrl"
                            placeholder="e.g. brightmediasolution.com"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.finalUrl}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="description">Description *</label>
                        <input
                            type="text"
                            name="description"
                            placeholder="Enter Ad Description Text"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.description}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-3">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="headline_part1">Headline Part 1 *</label>
                        <input
                            type="text"
                            name="headline_part1"
                            placeholder="Enter Headline Part 1"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.headline_part1}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-3">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="headline_part2">Headline Part 2 *</label>
                        <input
                            type="text"
                            name="headline_part2"
                            placeholder="Enter Headline Part 2"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.headline_part2}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="sitelinks">Sitelinks *</label>
                        <input
                            type="text"
                            name="sitelinks"
                            placeholder="Enter comma-separated sitelinks (e.g. Contact, Services, Pricing)"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.sitelinks}
                            onChange={onChange}
                        />
                        <small className="form-text text-muted">Include up to 4 comma-separated sub-navigation links for the search result.</small>
                    </div>
                </div>
            </div>
            <div className='col-5 pl-4 d-flex align-items-center justify-content-center'>
                <div className="w-100">
                    <GoogleSearchAd finalUrl={dataItem?.finalUrl} headline1={dataItem?.headline_part1} headline2={dataItem?.headline_part2} description={dataItem?.description} sitelinks={dataItem?.sitelinks ? dataItem?.sitelinks?.split(',').map(s => s.trim()).filter(Boolean) : []} />
                </div>
            </div>
        </div>
    )
}

export default GoogleAdsetForm